import { SyntheticEvent } from 'react';

export const onImageError = (event: SyntheticEvent<HTMLImageElement>) => {
  event.currentTarget.src = '/DEFAULT_PHOTO.png';
};
